import { render, staticRenderFns } from "./KeyArchive.vue?vue&type=template&id=9e84c10e&"
import script from "./KeyArchive.vue?vue&type=script&lang=ts&"
export * from "./KeyArchive.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports